import { CommonModule } from '@angular/common';
import { Component, Input, booleanAttribute, numberAttribute } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-info-tooltip',
  standalone: true,
  imports: [CommonModule, FontAwesomeModule, NgbTooltipModule],
  templateUrl: './info-tooltip.component.html',
  styleUrls: ['./info-tooltip.component.scss']
})
export class InfoTooltipComponent {
  @Input() title = '';
  @Input() text = '';
  @Input() lines: string[] = [];
  @Input() placement = 'top';
  @Input({ transform: booleanAttribute }) compact = false;
  @Input({ transform: numberAttribute }) openDelay = 0;
  @Input() label = 'More information';

  readonly icon = faCircleInfo;

  get hasTooltipContent(): boolean {
    return !!this.title.trim() || !!this.text.trim() || this.lines.length > 0;
  }
}
